import { render } from "./PedometerMenu.vue?vue&type=template&id=f3824e5a"
import script from "./PedometerMenu.vue?vue&type=script&lang=js"
export * from "./PedometerMenu.vue?vue&type=script&lang=js"

import exportComponent from "/builds/ser-kso/new-claim-form/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__